export enum RentalEndpoints {
    BallotDownload = "ms-ux-mep-gestion-de-documentos-cliente-pga/servicio-al-cliente/v1/api/insureds/me/insurances/all/policies/:policyId/ballots/download",
}
